<template>
  <div class="about">
    <b-row>
      <b-col sm="3" class="about-img">
        <img src="../assets/logo.png" alt="Versada inmobiliaria en Pontevedra" />
      </b-col>
      <b-col sm="9" class="history">
        <h2>Versada, tu inmobiliaria en Pontevedra</h2>
        <p>Versada es una empresa llena de ilusión que surge ante la necesidad de dar una respuesta a las carencias y demandas del sector inmobiliario. Versada es el trato personal, acompañado por el buen hacer en el que la experiencia es algo más que una seña de identidad.</p>
        <p>Versada, tu inmobiliaria de confianza.</p>
        <p>Puedes contactarnos en el teléfono: 664 871 207 o en nuestro correo: info@versadainmobiliaria.com</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>

<style>
.about {
  margin: 50px 15px;
}
.history {
  color: #fff;
  background-color: #0085ca;
  border-radius: 5px;
  padding: 10px 20px;
}
.history h2 {
  color: white !important;
}
a {
  text-decoration: none !important;
}
.about-img img {
  padding-top: 60px;
}
@media (max-width: 767px) {
  .about-img img {
    padding-top: 0px;
    padding-bottom: 30px;
  }
}
</style>